import types from './types';
import create from '~/misc/create';
import {difference, cloneDeep} from 'lodash';
import * as modes from '~/modules/modal/modes';
import {saveOrHideOrViewLoads, getLoads, getBidLoads, getBookingLoads} from '~/api/loads';
import {loadsHideTheCompany, clearChecked ,updateChecked} from '~/modules/loadsSearch/actions';
import { loadsHideTheCompany as cityRatioLoadsHideTheCompany, updateChecked as cityRatioUpdateChecked,clearChecked as cityRatioClearChecked} from '~/modules/cityRatioList/actions';
import {similarHideTheCompany, clearSimilarChecked, updateSimilarChecked} from '~/modules/similarLoads/actions';
import {filterChecked} from '~/misc/checked';
import {companyBroker} from '~/api/company';
import {modalChange} from '~/modules/modal/actions';
import { getBidsLoads as getBidsLoadsAction } from '~/modules/bids/actions';
import { getMyBookingsAction } from '../bookings/action';

const localRecord = (checked, total, token, isMember) => {
  if (isMember) {return true;}
  const date = new Date();
  const time = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
  const num = JSON.parse(localStorage.getItem('savedTimes')) || {};
  const saved = (num[token] && num[token][time]) || [];
  const savedNum = saved.length || 0;
  const toSaved = checked.filter(val => saved.indexOf(val) === -1);
  const len = toSaved.length;
  if (savedNum + len > total) {
    // 超过次数
    return false;
  }
    // 没有超过
  const obj = Object.assign(num, {[token]: {[time]: saved.concat(toSaved)}});
  localStorage.setItem('savedTimes', JSON.stringify(obj));
  return true;
};


const formate = (getState, type, id, company, ble) => {
  const arr = cloneDeep(getState().myLoads[type].results.shipments);
  arr.forEach(ele => {
    if (ele.broker_id === id || ele.company === company) {
      ele.checkedBroker = ble;
    }
  });
  return arr;
};


export const saveLoadCityRatio = (type) => (dispatch, getState) => {
  let checked = filterChecked(getState().cityRatioList.results.shipments)
  if (checked.length === 0) {return;}
  const times = getState().premiumSwitch.memberSwitchData.times;
  const swi = getState().premiumSwitch.memberSwitchData.switch;
  const token = getState().user.token;
  const isMember = swi === 0 || getState().account.accountLevel > getState().account.free;
  if (localRecord(checked, times, token, isMember)) {
    saveOrHideOrViewLoads(getState, checked, 'saved').then(() => {
      dispatch(cityRatioUpdateChecked());
      dispatch(checkDialog(true));
      setTimeout(() => {
        dispatch(checkDialog(false));
      }, 3000);
    });
  } else {
    dispatch(modalChange(modes.POP, 'pop_upgrade_to_save'));
  }
};

// hide
export const hideLoadCityRatio = (type) => (dispatch, getState) => {
  const checked = filterChecked(getState().cityRatioList.results.shipments)
  if (checked.length === 0) {return;}
  saveOrHideOrViewLoads(getState, checked, 'hide').then(() => {
    dispatch(cityRatioLoadsHideTheCompany());
    dispatch(cityRatioClearChecked());
  });
};

// save
export const saveLoad = (type) => (dispatch, getState) => {
  let checked = type === 'loads'
    ? filterChecked(getState().loadsSearch.results.shipments)
    : filterChecked(getState().similarLoads.results.shipments);
  if (checked.length === 0) {return;}
  const checkedArr = type === 'loads' ? getState().loadsSearch.checked : getState().similarLoads.checked;
  checked = difference(checked, checkedArr);
  if (checked.length === 0) {return;}
  const times = getState().premiumSwitch.memberSwitchData.times;
  const swi = getState().premiumSwitch.memberSwitchData.switch;
  const token = getState().user.token;
  const isMember = swi === 0 || getState().account.accountLevel > getState().account.free;
  if (localRecord(checked, times, token, isMember)) {
    saveOrHideOrViewLoads(getState, checked, 'saved').then(() => {
      if (type === 'loads') {
        dispatch(updateChecked());
      } else {
        dispatch(updateSimilarChecked());
      }
      dispatch(checkDialog(true));
      setTimeout(() => {
        dispatch(checkDialog(false));
      }, 3000);
    });
  } else {
    dispatch(modalChange(modes.POP, 'pop_upgrade_to_save'));
  }
};

// hide
export const hideLoad = (type) => (dispatch, getState) => {
  const checked = type === 'loads'
    ? filterChecked(getState().loadsSearch.results.shipments)
    : filterChecked(getState().similarLoads.results.shipments);
  if (checked.length === 0) {return;}
  saveOrHideOrViewLoads(getState, checked, 'hide').then(() => {
    if (type === 'loads') {
      dispatch(loadsHideTheCompany(checked));
      dispatch(clearChecked());
    } else {
      dispatch(similarHideTheCompany(checked));
      dispatch(clearSimilarChecked());
    }
  });
};

// viewed
export const viewLoad = (id) => (dispatch, getState) => saveOrHideOrViewLoads(getState, [id], 'viewed');

// 控制弹窗的弹出
export const checkDialog = (bol) => create(types.CHECK_DIALOG, {bol});

const update = (type, fn, dispatch, getState) => {
  dispatch(create(types.UPDATE_STATUS, {type: type, status: 'loading'}));
  fn(getState, type).then(res => {
    dispatch(create(types.UPDATE_MYLOADS, {type: type, val: res}));
  }).then(() => {
    dispatch(create(types.UPDATE_STATUS, {type: type, status: 'ok'}));
  });
};


// 更新save/hide/view/bid/booking
export const updateMyloads = () => (dispatch, getState) => {
  update('saved', getLoads , dispatch, getState);
  update('hide', getLoads,  dispatch, getState);
  update('viewed', getLoads,  dispatch, getState);
  update('bid', getBidLoads,  dispatch, getState);
  update('booking', getBookingLoads, dispatch, getState);
  dispatch(getBidsLoadsAction());
  dispatch(getMyBookingsAction());
};

// save broker
export const saveBroker = (data) => (dispatch, getState) => {
  const id = data.id;
  const company = data.company;
  const savedArr = formate(getState, 'saved', id, company, true);
  const hideArr = formate(getState, 'hide', id, company, true);
  const viewedArr = formate(getState, 'viewed', id, company, true);
  const bidArr = formate(getState, 'bid', id, company, true);
  const bookingArr = formate(getState, 'booking', id, company, true);
  const noSavedArr = formate(getState, 'saved', id, company, false);
  const noHideArr = formate(getState, 'hide', id, company, false);
  const noViewedArr = formate(getState, 'viewed', id, company, false);
  const noBidArr = formate(getState, 'bid', id, company, false);
  const noBookingArr = formate(getState, 'booking', id, company, false);
  dispatch(create(types.SAVE_BROKER, {savedArr, hideArr, viewedArr, bidArr, bookingArr}));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'save'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.SAVE_BROKER, {savedArr, hideArr, viewedArr, bidArr, bookingArr}));
      } else if (response.code === 500) {
        dispatch(create(types.SAVE_BROKER, {savedArr: noSavedArr, hideArr: noHideArr, viewedArr: noViewedArr, bidArr: noBidArr, bookingArr:  noBookingArr}));
      }
    }, () => {
      dispatch(create(types.SAVE_BROKER, {savedArr: noSavedArr, hideArr: noHideArr, viewedArr: noViewedArr, bidArr: noBidArr, bookingArr:  noBookingArr}));
    });
};
// no-save broker
export const noSaveBroker = (data) => (dispatch, getState) => {
  const id = data.id;
  const company = data.company;
  const savedArr = formate(getState, 'saved', id, company, true);
  const hideArr = formate(getState, 'hide', id, company, true);
  const viewedArr = formate(getState, 'viewed', id, company, true);
  const bidArr = formate(getState, 'bid', id, company, true);
  const bookingArr = formate(getState, 'booking', id, company, true);
  const noSavedArr = formate(getState, 'saved', id, company, false);
  const noHideArr = formate(getState, 'hide', id, company, false);
  const noViewedArr = formate(getState, 'viewed', id, company, false);
  const noBidArr = formate(getState, 'bid', id, company, false);
  const noBookingArr = formate(getState, 'booking', id, company, false);
  dispatch(create(types.SAVE_BROKER, {savedArr: noSavedArr, hideArr: noHideArr, viewedArr: noViewedArr, bidArr: noBidArr, bookingArr:  noBookingArr}));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'remove'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.SAVE_BROKER, {savedArr: noSavedArr, hideArr: noHideArr, viewedArr: noViewedArr, bidArr: noBidArr, bookingArr:  noBookingArr }));
      } else if (response.code === 500) {
        dispatch(create(types.NO_SAVE_BROKER, {savedArr, hideArr, viewedArr, bidArr, bookingArr}));
      }
    }, () => {
      dispatch(create(types.NO_SAVE_BROKER, {savedArr, hideArr, viewedArr, bidArr, bookingArr}));
    });
};
export const hideBroker = (data) => (dispatch, getState) => {
  companyBroker(getState, {id: data.id, company: data.company, operate: 'hide'});
};

export const deletBookingList=(id)=>(dispatch, getState)=>{
  dispatch({type: types.DELETE_BOOKING_LOADS, payload: {loadId: id}})
}


// WEBPACK FOOTER //
// ./src/modules/myLoads/actions.js